module.exports = __webpack_public_path__ + "img/target-mockup.f23b91a4.webp";